document.addEventListener('DOMContentLoaded', function () {

  localStorage.clear();

  const SITE_ID = '5op9sn';
  const SECTION_ID = 'search-grid-2';
  const CACHE_DURATION_MINUTES = 5;
  const RESULTS_PER_PAGE = 26;

  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const isCollectionPage = pathParts.includes('collections');
  const collectionHandle = isCollectionPage ? pathParts[pathParts.indexOf('collections') + 1] : null;
  if (!isCollectionPage || !collectionHandle) return;

  const productGrid = document.querySelector('#product-grid-2');
  if (!productGrid) {
    console.warn('❗ #product-grid-2 not found — cannot render collection products.');
    return;
  }

  const shopifyRoot = Shopify?.routes?.root || '/';
  let currentPage = 1;
  let isFetching = false;
  let hasMorePages = true;
  let totalProductCount = 0;
  let featuredSectionIndex = 0;

  // --- Featured Grids Configuration ---
  let featuredGridsConfig = [];
  try {
    const featuredGridsData = productGrid.dataset.featuredGrids || productGrid.getAttribute('data-featured-grids');
    const blocksCount = productGrid.getAttribute('data-featured-grid-blocks-count') || '0';
    
    console.log('🔍 INITIAL CHECK:', {
      hasDataAttribute: !!featuredGridsData,
      dataLength: featuredGridsData ? featuredGridsData.length : 0,
      blocksCount: blocksCount,
      rawData: featuredGridsData
    });
    
    if (featuredGridsData && featuredGridsData !== '[]' && featuredGridsData.trim() !== '') {
      try {
        featuredGridsConfig = JSON.parse(featuredGridsData);
        console.log('✅ Successfully parsed featured grids:', featuredGridsConfig);
        
        // Validate each config - need collection_handle and either image_url or video_url
        featuredGridsConfig = featuredGridsConfig.filter(config => {
          const hasCollection = config.collection_handle && config.collection_handle.trim() !== '';
          const hasImage = config.image_url && config.image_url.trim() !== '';
          const hasVideo = config.video_url && config.video_url.trim() !== '';
          const hasMedia = hasImage || hasVideo;
          const isValid = hasCollection && hasMedia;
          if (!isValid) {
            console.warn('⚠️ Filtering out invalid config:', {
              hasCollection,
              hasImage,
              hasVideo,
              config
            });
          }
          return isValid;
        });
        
        featuredGridsConfig.sort((a, b) => a.position - b.position);
        console.log(`📊 Valid featured grids after filtering: ${featuredGridsConfig.length}`, featuredGridsConfig);
      } catch (parseErr) {
        console.error('❌ JSON parse error:', parseErr);
        console.error('Raw data that failed to parse:', featuredGridsData);
        featuredGridsConfig = [];
      }
    } else {
      console.log('ℹ️ No featured grids data found or empty array');
      const blocksWithData = productGrid.getAttribute('data-featured-grid-blocks-with-data') || '0';
      if (blocksWithData && blocksWithData !== '0') {
        console.warn(`⚠️ Found ${blocksWithData} Featured Grid block(s) but no data.`);
        console.warn(`💡 Please select collection and upload image in Theme Editor → Featured Grid block settings`);
      }
    }
  } catch (err) {
    console.error('❌ Failed to parse featured grids configuration:', err);
    featuredGridsConfig = [];
  }

  const usedFeaturedGrids = new Set();

  // --- Active State ---
  var activeFilters = { product_type: [], tags_colour: [], variant_size: [], tags_fabric: [] };
  var activeSort = '';

  window.toggleFilter = toggleFilter;
  window.applySort = applySort;
  window.applyFilter = applyFilter;

  // ========================
  // URL PARAMS
  // ========================
  const urlParams = new URLSearchParams(window.location.search);
  const sortParam = urlParams.get('sort_by');

  ['product_type', 'variant_size', 'tags_colour', 'tags_fabric'].forEach(key => {
    const values = urlParams.getAll(key);
    if (values.length > 0) {
      if (!activeFilters[key]) activeFilters[key] = [];
      values.forEach(v => {
        activeFilters[key].push(v);
      });
    }
  });

  if (sortParam) {
    let field = '';
    let direction = '';

    switch (sortParam) {
      case 'manual':
        field = 'featured';
        direction = 'desc';
        break;
      case 'title-ascending':
        field = 'title';
        direction = 'asc';
        break;
      case 'title-descending':
        field = 'title';
        direction = 'desc';
        break;
      case 'price-ascending':
        field = 'ss_price';
        direction = 'asc';
        break;
      case 'price-descending':
        field = 'ss_price';
        direction = 'desc';
        break;
      default:
        field = 'featured';
        direction = 'desc';
    }

    const radioInput = document.querySelector(`input[name="sort_by"][value="${sortParam}"]`);
    if (radioInput) radioInput.checked = true;

    activeSort = `${field}:${direction}`;
  }

  function toggleFilter(type, value) {
    if (!activeFilters[type]) activeFilters[type] = [];
    const index = activeFilters[type].indexOf(value);
    if (index > -1) {
      activeFilters[type].splice(index, 1);
      if (activeFilters[type].length === 0) delete activeFilters[type];
    } else {
      activeFilters[type].push(value);
    }
    resetCollection();
  }

  function applySort(field, direction) {
    activeSort = `${field}:${direction}`;
    resetCollection();
  }

  function renderSearchspringFilters(facets) {
    const filterContainer = document.querySelector('.filter-wrap');
    if (!filterContainer) return;

    filterContainer.innerHTML = '';

    facets.forEach(facet => {
      if (
        facet.field === 'ss_price' ||
        facet.label?.toLowerCase().includes('price') ||
        facet.type === 'range'
      ) {
        return;
      }

      if (!facet.values || facet.values.length === 0) return;

      const facetWrap = document.createElement('div');
      facetWrap.className = 'facet-list filter-inr filter-index';
      facetWrap.innerHTML = `
        <div class="filter-title">
          <span>${facet.label}</span>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
              <path d="M5.262 9.01699L5.262 0.812988L4.03 0.812988L4.03 9.01699L1.076 6.04899L0.291999 6.83299L4.646 11.187L9 6.83299L8.23 6.04899L5.262 9.01699Z" fill="black"></path>
            </svg>
          </span>
        </div>
        <ul class="filter-inr-wrap"></ul>
      `;

      const list = facetWrap.querySelector('.filter-inr-wrap');

      let values = facet.values;

      if (facet.field === 'variant_size') {
        const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'OS'];

        const alphaSizes = [];
        const numericSizes = [];
        const others = [];

        values.forEach(v => {
          const val = (v.value || v.label || '').toUpperCase().trim();
          if (sizeOrder.includes(val)) {
            alphaSizes.push(v);
          } else if (/^[0-9]+$/.test(val)) {
            numericSizes.push(v);
          } else {
            others.push(v);
          }
        });

        alphaSizes.sort((a, b) => {
          const va = (a.value || a.label || '').toUpperCase();
          const vb = (b.value || b.label || '').toUpperCase();
          return sizeOrder.indexOf(va) - sizeOrder.indexOf(vb);
        });

        numericSizes.sort((a, b) => parseInt(a.value) - parseInt(b.value));
        others.sort((a, b) => (a.label || '').localeCompare(b.label || ''));

        values = [...alphaSizes, ...numericSizes, ...others];
      }

      values.forEach(v => {
        const val = v.value || v.label || `${v.low}-${v.high}` || 'unknown';
        const safeId = `${facet.field}-${val.replace(/\s+/g, '-').toLowerCase()}`;
        const isChecked =
          activeFilters[facet.field] && activeFilters[facet.field].includes(val);

        const li = document.createElement('li');
        li.innerHTML = `
          <input class="facet-input"
                type="checkbox"
                id="${safeId}"
                name="${facet.field}"
                value="${val}"
                ${isChecked ? 'checked' : ''}
                onchange="toggleFilter('${facet.field}', '${val}')">
          <label for="${safeId}">${v.label || val}</label>
        `;
        list.appendChild(li);
      });

      filterContainer.appendChild(facetWrap);
    });
  }

  function applyFilter() {
    activeFilters = { product_type: [], tags_colour: [], variant_size: [], tags_fabric: [] };
    setTimeout(function () {
      document.querySelectorAll('.wc_filter_option:checked').forEach(function (self) {
        var field_value = self.getAttribute('data-param-name');
        if (field_value.includes('product_type')) {
          activeFilters.product_type.push(self.value);
        }
        if (field_value.includes('filter.v.option.size')) {
          activeFilters.variant_size.push(self.value);
        }
        if (field_value.includes('filter.p.m.custom.color')) {
          activeFilters.tags_colour.push(self.value);
        }
        if (field_value.includes('filter.p.m.custom.fabric')) {
          activeFilters.tags_fabric.push(self.value);
        }
      });
      resetCollection();
      
    }, 500);
  }

  function buildSearchspringParams() {
    let params = [];

    Object.entries(activeFilters).forEach(([key, values]) => {
      values.forEach(val => {
        params.push(`filter.${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
      });
    });

    if (activeSort) {
      const [field, dir] = activeSort.split(':');
      params.push(`sort.${encodeURIComponent(field)}=${encodeURIComponent(dir)}`);
    }

    return params.join('&');
  }

  // ========================
  // CACHE
  // ========================
  function getCachedProduct(handle) {
    const cacheKey = `product_html_${handle}`;
    const cached = localStorage.getItem(cacheKey);
    if (!cached) return null;
    const parsed = JSON.parse(cached);
    const now = Date.now();
    if (now - parsed.timestamp < CACHE_DURATION_MINUTES * 60 * 1000) {
      return parsed.html;
    } else {
      localStorage.removeItem(cacheKey);
      return null;
    }
  }

  function setCachedProduct(handle, html) {
    const cacheKey = `product_html_${handle}`;
    localStorage.setItem(
      cacheKey,
      JSON.stringify({ timestamp: Date.now(), html })
    );
  }

  // ========================
  // FEATURED PRODUCT FETCH
  // ========================
  async function fetchFeaturedProduct(handle) {
    if (!handle || handle.trim() === '') {
      console.warn(`⚠️ fetchFeaturedProduct called with empty handle`);
      return null;
    }
    
    console.log(`📥 Fetching featured product: ${handle}`);
    
    const cachedHTML = getCachedProduct(handle);
    if (cachedHTML) {
      console.log(`✅ Using cached HTML for: ${handle}`);
      return cachedHTML;
    }

    try {
      const url = `${shopifyRoot}products/${handle}?sections=${SECTION_ID}`;
      console.log(`🌐 Fetching from: ${url}`);
      const res = await fetch(url);
      
      if (!res.ok) {
        console.error(`❌ HTTP ${res.status} error fetching product: ${handle}`);
        return null;
      }
      
      const json = await res.json();
      const html = json?.[SECTION_ID];

      if (!html || html.trim() === '' || html.trim() === `<div id="shopify-section-${SECTION_ID}" class="shopify-section"></div>`) {
        console.warn(`⚠️ No HTML found for featured product: ${handle}`);
        return null;
      }

      setCachedProduct(handle, html);
      console.log(`✅ Successfully fetched and cached product: ${handle}`);
      return html;
    } catch (err) {
      console.error(`❌ Failed to fetch featured product: ${handle}`, err);
      return null;
    }
  }

  // ========================
  // COLLECTION FETCH LOGIC
  // ========================
  async function fetchCollectionPage(page = 1) {
    if (isFetching || !hasMorePages) return;
    isFetching = true;

    const loader = document.querySelector('.look-cart-loader-inner');
    if (loader) loader.style.display = 'flex';

    try {
      const extraParams = buildSearchspringParams();
      const apiURL = `https://${SITE_ID}.a.searchspring.io/api/search/search.json?siteId=${SITE_ID}&resultsFormat=json&bgfilter.collection_handle=${collectionHandle}&page=${page}&resultsPerPage=${RESULTS_PER_PAGE}${extraParams ? '&' + extraParams : ''}`;

      const response = await fetch(apiURL);
      const data = await response.json();
      
      if (page === 1 && data.facets) {
        renderSearchspringFilters(data.facets);
        setTimeout(() => {
          if (typeof filter_accod === 'function') filter_accod();
          if (typeof ensureGridImagesUpdate === 'function') ensureGridImagesUpdate();
        }, 300);
      }
      
      if (!data.results || data.results.length === 0) {
        if (page === 1) productGrid.innerHTML = `<div class="no-results">No products found.</div>`;
        hasMorePages = false;
        return;
      }

      const handles = data.results.map(p => p.handle).filter(Boolean);
      const sectionPromises = handles.map(async (handle, index) => {
        const cachedHTML = getCachedProduct(handle);
        const productData = data.results[index];
        
        if (cachedHTML) return { index, html: cachedHTML, handle };

        try {
          const res = await fetch(`${shopifyRoot}products/${handle}?sections=${SECTION_ID}`);
          const json = await res.json();
          const html = json?.[SECTION_ID];

          if (!html) {
            const fallbackHTML = `
              <div class="fallback-product">
                <a href="${shopifyRoot}products/${productData.handle}">
                  <img src="${productData.imageUrl || productData.image || ''}" alt="${productData.name || ''}" loading="lazy">
                  <h3>${productData.name || ''}</h3>
                  <p>${productData.price || ''}</p>
                </a>
              </div>`;
            setCachedProduct(handle, fallbackHTML);
            return { index, html: fallbackHTML, handle };
          }

          setCachedProduct(handle, html);
          if (!html || html.trim() === '' || html.trim() === `<div id="shopify-section-${SECTION_ID}" class="shopify-section"></div>`) {
            return { index: ``, html: ``, handle: `` };
          } else {
            return { index, html, handle };
          }
        } catch (err) {
          console.warn(`❌ Section fetch failed: ${handle}`, err);
          return { index, html: `<div class="error">Failed to load ${handle}</div>`, handle };
        }
      });

      const sections = await Promise.all(sectionPromises);
      sections.sort((a, b) => a.index - b.index);
      const validSections = sections.filter(s => s.html && s.html.trim() !== '');
      
      const isMobile = window.innerWidth <= 1024;
      
      function shouldInsertFeaturedSection(currentPosition) {
        if (featuredGridsConfig.length === 0) {
          return null;
        }
        
        console.log(`🔍 [Position ${currentPosition}] Checking featured grids`, {
          isMobile: isMobile,
          totalConfigs: featuredGridsConfig.length
        });
        
        for (const gridConfig of featuredGridsConfig) {
          const configKey = `${gridConfig.collection_handle}_${gridConfig.position}_${gridConfig.mobile_position}`;
          
          if (usedFeaturedGrids.has(configKey)) {
            continue;
          }
          
          const targetPosition = isMobile ? gridConfig.mobile_position : gridConfig.position;
          
          console.log(`   Comparing position ${currentPosition} with target ${targetPosition} (${isMobile ? 'mobile' : 'desktop'})`);
          
          if (currentPosition === targetPosition) {
            console.log(`✅ MATCH! Inserting featured grid at position ${currentPosition}`);
            return gridConfig;
          }
        }
        return null;
      }
      
      let htmlToInsert = '';
      let i = 0;
      let productsInserted = 0;
      
      // Track ONLY regular products in the main grid for border calculation
      // Featured sections don't count toward grid position - they take full rows
      const productsPerRow = isMobile ? 2 : 4;
      
      // Calculate initial grid position by counting existing regular products in DOM
      // This ensures correct border calculation when loading additional pages
      // Count only direct .product-item children (regular products)
      // Featured section products are inside .featured-section, so they're not direct children
      const existingRegularProducts = Array.from(productGrid.children).filter(child => 
        child.classList.contains('product-item')
      ).length;
      let regularProductCount = existingRegularProducts;
      let gridPosition = existingRegularProducts % productsPerRow;
      
      console.log(`🚀 Starting insertion:`, {
        validSections: validSections.length,
        totalProductCount: totalProductCount,
        existingRegularProducts: existingRegularProducts,
        initialGridPosition: gridPosition,
        productsPerRow: productsPerRow,
        featuredGridsConfigured: featuredGridsConfig.length,
        isMobile: isMobile
      });
      
      while (i < validSections.length) {
        // Use regular product count for featured section position matching
        // This ensures featured sections are inserted at the correct position
        const currentIndex = regularProductCount;
        
        const featuredGridConfig = shouldInsertFeaturedSection(currentIndex);
        
        if (featuredGridConfig) {
          const configKey = `${featuredGridConfig.collection_handle}_${featuredGridConfig.position}_${featuredGridConfig.mobile_position}`;
          usedFeaturedGrids.add(configKey);
          
          console.log(`🎯 Inserting featured section at regular product position ${currentIndex} (grid position: ${gridPosition})`, featuredGridConfig);
          
          // Check if we have enough products for surrounding products (need 4)
          const productsRemaining = validSections.length - i;
          if (productsRemaining < 4) {
            console.warn(`⚠️ Not enough products remaining (${productsRemaining}) for featured section - need 4. Skipping.`);
            // Continue with regular product insertion
          } else {
            // Grab the next 4 products from collection results as surrounding products
            const product1HTML = validSections[i].html;
            const product2HTML = validSections[i + 1].html;
            const product3HTML = validSections[i + 2].html;
            const product4HTML = validSections[i + 3].html;
            
            // Generate media HTML for 2x2 space (supports both image and video)
            const mediaType = featuredGridConfig.media_type || 'image';
            let imageUrl = featuredGridConfig.image_url || '';
            const imageAlt = featuredGridConfig.image_alt || '';
            let videoUrl = featuredGridConfig.video_url || '';
            let videoSources = featuredGridConfig.video_sources || null;
            const customUrl = featuredGridConfig.url || '';
            
            // Ensure image URL has protocol (fix protocol-relative URLs)
            if (imageUrl && imageUrl.startsWith('//')) {
              imageUrl = `https:${imageUrl}`;
            } else if (imageUrl && !imageUrl.startsWith('http://') && !imageUrl.startsWith('https://') && !imageUrl.startsWith('/')) {
              if (!imageUrl.startsWith('//')) {
                imageUrl = `https:${imageUrl}`;
              }
            }
            
            // Ensure video URL has protocol
            if (videoUrl && videoUrl.startsWith('//')) {
              videoUrl = `https:${videoUrl}`;
            } else if (videoUrl && !videoUrl.startsWith('http://') && !videoUrl.startsWith('https://') && !videoUrl.startsWith('/')) {
              if (!videoUrl.startsWith('//')) {
                videoUrl = `https:${videoUrl}`;
              }
            }
            
            let mediaHTML = '';
            
            // Generate video HTML if video is available
            if (mediaType === 'video' && (videoUrl || videoSources)) {
              let videoTag = '';
              
              // Parse video sources if it's a string
              let parsedVideoSources = null;
              if (videoSources) {
                if (typeof videoSources === 'string') {
                  try {
                    parsedVideoSources = JSON.parse(videoSources);
                  } catch (e) {
                    console.warn('Failed to parse video sources:', e);
                    parsedVideoSources = null;
                  }
                } else if (Array.isArray(videoSources)) {
                  parsedVideoSources = videoSources;
                }
              }
              
              // If we have video sources array, use it for multiple formats
              if (parsedVideoSources && Array.isArray(parsedVideoSources) && parsedVideoSources.length > 0) {
                const sourceTags = parsedVideoSources.map(source => {
                  const src = source.url || source.src || '';
                  const type = source.mime_type || source.type || 'video/mp4';
                  if (src) {
                    return `<source src="${src}" type="${type}">`;
                  }
                  return '';
                }).filter(tag => tag !== '').join('');
                
                if (sourceTags) {
                  videoTag = `<video autoplay muted loop playsinline preload="metadata" style="width: 100%; height: 100%; object-fit: cover; background: #000;" class="featured-video">${sourceTags}</video>`;
                }
              }
              
              // Fallback to single video URL if no sources or sources failed
              if (!videoTag && videoUrl && videoUrl.trim() !== '') {
                videoTag = `<video src="${videoUrl}" autoplay muted loop playsinline preload="metadata" style="width: 100%; height: 100%; object-fit: cover; background: #000;" class="featured-video"></video>`;
              }
              
              if (videoTag) {
                if (customUrl && customUrl.trim() !== '') {
                  mediaHTML = `<a href="${customUrl}" class="featured-media-link">${videoTag}</a>`;
                } else {
                  mediaHTML = videoTag;
                }
              } else {
                console.warn('⚠️ Featured video: No valid video URL or sources found', {
                  videoUrl: videoUrl,
                  videoSources: parsedVideoSources,
                  mediaType: mediaType
                });
              }
            } 
            // Fallback to image if no video or video failed
            else if (imageUrl) {
              if (customUrl && customUrl.trim() !== '') {
                mediaHTML = `<a href="${customUrl}" class="featured-image-link"><img src="${imageUrl}" alt="${imageAlt}" loading="lazy" style="width: 100%; height: 100%; object-fit: cover;"></a>`;
              } else {
                mediaHTML = `<img src="${imageUrl}" alt="${imageAlt}" loading="lazy" style="width: 100%; height: 100%; object-fit: cover;">`;
              }
            }
            
            console.log(`📦 Featured section data:`, {
              mediaType: mediaType,
              imageUrl: imageUrl,
              videoUrl: videoUrl,
              imageAlt: imageAlt,
              customUrl: customUrl,
              product1: !!product1HTML,
              product2: !!product2HTML,
              product3: !!product3HTML,
              product4: !!product4HTML,
              mediaHTMLGenerated: !!mediaHTML
            });
            
            if (isMobile) {
              if (mediaHTML) {
                const featuredHTML = `
                  <div class="featured-section">
                    <div class="product-item featured-2x2">${mediaHTML}</div>
                  </div>`;
                htmlToInsert += featuredHTML;
                productsInserted += 1; // For total count
                // Featured section takes full row on mobile (2 columns)
                // Reset grid position - next regular product starts new row
                gridPosition = 0;
                // Skip the 4 products we used for surrounding (they're hidden on mobile anyway)
                i += 4;
                // Don't increment regularProductCount - featured section doesn't count as regular product
                console.log(`✅ Mobile featured section inserted - grid position reset to 0`);
              } else {
                console.warn(`⚠️ Featured media missing - skipping featured section`);
              }
            } else {
              if (mediaHTML && product1HTML && product2HTML && product3HTML && product4HTML) {
                const isRightSide = featuredGridConfig.layout === 'right';
                const sectionClass = isRightSide ? 'featured-section featured-right' : 'featured-section featured-left';
                
                let featuredHTML = '';
                if (isRightSide) {
                  featuredHTML = `
                    <div class="${sectionClass}">
                      <div class="product-item">${product1HTML}</div>
                      <div class="product-item">${product2HTML}</div>
                      <div class="product-item featured-2x2">${mediaHTML}</div>
                      <div class="product-item">${product3HTML}</div>
                      <div class="product-item">${product4HTML}</div>
                    </div>`;
                } else {
                  featuredHTML = `
                    <div class="${sectionClass}">
                      <div class="product-item featured-2x2">${mediaHTML}</div>
                      <div class="product-item">${product1HTML}</div>
                      <div class="product-item">${product2HTML}</div>
                      <div class="product-item">${product3HTML}</div>
                      <div class="product-item">${product4HTML}</div>
                    </div>`;
                }
                
                htmlToInsert += featuredHTML;
                productsInserted += 5; // For total count (4 products + 1 featured section)
                featuredSectionIndex++;
                // Skip the 4 products we used for surrounding
                i += 4;
                // Featured section takes full row on desktop (4 columns)
                // Reset grid position - next regular product starts new row
                gridPosition = 0;
                // Don't increment regularProductCount - featured section doesn't count as regular product
                console.log(`✅ Desktop featured section inserted (${isRightSide ? 'right' : 'left'} layout) - grid position reset to 0`);
              } else {
                const missingItems = [];
                if (!mediaHTML) missingItems.push('media');
                if (!product1HTML) missingItems.push('product_1');
                if (!product2HTML) missingItems.push('product_2');
                if (!product3HTML) missingItems.push('product_3');
                if (!product4HTML) missingItems.push('product_4');
                console.warn(`⚠️ Featured section skipped - missing: ${missingItems.join(', ')}`);
              }
            }
          }
        } else {
          // Regular product insertion
          const productsRemaining = validSections.length - i;
          
          // Check if we have enough products to complete the row
          const productsNeededToCompleteRow = productsPerRow - gridPosition;
          
          if (gridPosition === 0 && productsRemaining < productsPerRow) {
            // Starting new row but not enough products to fill it
            break;
          } else if (gridPosition > 0 && productsRemaining < productsNeededToCompleteRow) {
            // In middle of row but not enough products to complete it
            break;
          }
          
          // Calculate if this is the last item in the row based on grid position
          const isEndOfRow = (gridPosition + 1) % productsPerRow === 0;
          const itemClass = isEndOfRow ? 'product-item no-right-border' : 'product-item';
          
          console.log(`📦 Inserting regular product ${i + 1}: gridPosition=${gridPosition}, isEndOfRow=${isEndOfRow}, class=${itemClass}`);
          
          htmlToInsert += `<div class="${itemClass}">${validSections[i].html}</div>`;
          i++;
          productsInserted++;
          regularProductCount++;
          // Update grid position for next iteration
          gridPosition = (gridPosition + 1) % productsPerRow;
        }
      }

      if (htmlToInsert.trim() !== '') {
        console.log(`💾 Inserting HTML (${productsInserted} items)`);
        productGrid.insertAdjacentHTML('beforeend', htmlToInsert);
        totalProductCount += productsInserted;
      } else {
        console.warn('⚠️ No HTML to insert');
      }

      if (typeof $th_refreshWishlistItems === 'function') $th_refreshWishlistItems();
      quickAddButton2();
      colorVariantClick2();

      document.querySelector('.collection-grid.placeholder-grid')?.style?.setProperty('display', 'none');
      if (data.pagination.currentPage == data.pagination.totalPages) {
        document.querySelector('#AjaxinatePagination')?.style?.setProperty('display', 'none');
      }
      if (!data.pagination?.nextPage) hasMorePages = false;
      currentPage++;
    } catch (err) {
      console.error('❌ Error fetching collection:', err);
      if (currentPage === 1) {
        productGrid.innerHTML = `<div class="error">Error loading products.</div>`;
      }
    } finally {
      isFetching = false;
      if (loader) setTimeout(() => (loader.style.display = 'none'), 100);
    }
  }

  // ========================
  // INITIAL LOAD (SKIP CACHE FOR NOW TO TEST)
  // ========================
  // Clear session cache to force fresh load
  const cacheKey = `collection_cache_${collectionHandle}`;
  sessionStorage.removeItem(cacheKey);
  console.log('🔄 Cache cleared - loading fresh data');
  
  fetchCollectionPage(currentPage);

  window.addEventListener('scroll', () => {
    if (isFetching || !hasMorePages) return;
    const scrollY = window.scrollY + window.innerHeight;
    const threshold = document.body.offsetHeight - 1000;
    if (scrollY >= threshold) fetchCollectionPage(currentPage);
  });

  function resetCollection() {
    productGrid.innerHTML = '';
    currentPage = 1;
    hasMorePages = true;
    totalProductCount = 0;
    featuredSectionIndex = 0;
    usedFeaturedGrids.clear();
    sessionStorage.removeItem(cacheKey); // Clear cache on reset
    fetchCollectionPage(currentPage);
  }

  function quickAddButton2() {
    document.querySelectorAll('.variant-grid').forEach(sizeList => {
      sizeList.addEventListener('click', e => {
        e.preventDefault();
        const variant_id = sizeList.dataset.id;
        const formData = { items: [{ id: variant_id, quantity: 1 }] };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        })
          .then(r => r.json())
          .then(() => {
            if(typeof load_cart == 'function'){
              load_cart();
              setTimeout(function(e){
                document.querySelector('body').classList.add('open-drawer');
              },2000);
            }else{
              window.location.href = "/cart";
            }
          })
          .catch(console.error);
      });
    });
  }

  function colorVariantClick2() {
    if (window.innerWidth > 1024) {
      document.querySelectorAll('.grid-bottom .main-color-variant .color-var.click').forEach(function (element) {
        element.addEventListener('click', function (event) {
          event.preventDefault();
          const attVal = this.getAttribute('data-id');
          const productItem = this.closest('.product-item');
          if (!productItem) return;

          const innerGrids = productItem.querySelectorAll('.snippet-product-grid .inner-product-grid');
          innerGrids.forEach(function (innerGrid) {
            if (attVal === innerGrid.getAttribute('data-id')) {
              innerGrids.forEach(g => g.classList.remove('active'));
              innerGrid.classList.add('active');
            }
          });
        });
      });
    }
  }

  // Handle featured video autoplay with Intersection Observer
  function initFeaturedVideos() {
    const featuredVideos = document.querySelectorAll('.featured-section .featured-video');
    
    if (featuredVideos.length === 0) return;
    
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            // Video is visible - try to play
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(error => {
                // Autoplay failed, but that's okay - browser policy
                console.log('Video autoplay prevented:', error);
              });
            }
          } else {
            // Video is not visible - pause to save resources
            video.pause();
          }
        });
      }, {
        threshold: 0.25 // Trigger when 25% of video is visible
      });
      
      featuredVideos.forEach(video => {
        // Ensure video attributes are set
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('muted', '');
        video.setAttribute('preload', 'metadata');
        
        videoObserver.observe(video);
      });
    } else {
      // Fallback for browsers without IntersectionObserver
      featuredVideos.forEach(video => {
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('muted', '');
        video.setAttribute('preload', 'metadata');
        
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log('Video autoplay prevented:', error);
          });
        }
      });
    }
  }

  // Initialize videos after content is loaded
  setTimeout(initFeaturedVideos, 500);
  
  // Re-initialize videos when new content is loaded (pagination, filters)
  const originalFetchCollectionPage = window.fetchCollectionPage;
  if (originalFetchCollectionPage) {
    window.fetchCollectionPage = function(...args) {
      const result = originalFetchCollectionPage.apply(this, args);
      setTimeout(initFeaturedVideos, 1000);
      return result;
    };
  }
});